import { Flex } from '@backyard-ui/core'

import { ArchivedMessageItem } from '../ArchivedMessageItem'

type Message = {
  id: string
  title: string
  date: string
  text?: string
}

type ArchivedMessageListProps = {
  list: Message[]
  onClick: (id: string) => void
}

const ArchivedMessageList = (props: Readonly<ArchivedMessageListProps>) => {
  const { list, onClick } = props
  return (
    <Flex direction="column">
      {list.map(item => (
        <div key={item.id} className="border-t border-gray-300 last:border-b">
          <ArchivedMessageItem data={item} onClick={onClick}>
            {item?.text ?? 'Conversa encerrada'}
          </ArchivedMessageItem>
        </div>
      ))}
    </Flex>
  )
}

export default ArchivedMessageList
